import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData,
  type CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError,
  type CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse,
  createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost,
} from '../../generated';

export type CreateUnlistedPdpMutationVariables = CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData['path'] &
  CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData['body'];

export type CreateUnlistedPdpMutation = CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse;

export const useCreateUnlistedPdpMutation = <
  TError = CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateUnlistedPdpMutation, TError, CreateUnlistedPdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateUnlistedPdpMutation, TError, CreateUnlistedPdpMutationVariables, TContext>({
    mutationKey: ['CreateUnlistedPdp'],
    mutationFn: async ({ workspace_id, ...body }: CreateUnlistedPdpMutationVariables) => {
      const { data } = await createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost({
        path: { workspace_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateUnlistedPdpMutation.fetcher = (
  { workspace_id, ...body }: CreateUnlistedPdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost({
      path: { workspace_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
